import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mdk-root',
  templateUrl: './app.container.html'
})

export class AppContainer implements OnInit {
  public title: string = 'PRIKVERWERKER';
  ngOnInit(): void {  }
}